var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSampleDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "#E3E3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 580087",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 716,
    height: 874,
    transform: "translate(-46 -539)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 580100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 580065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 580107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 580105"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -26,
    y: -172,
    width: 333,
    height: 219,
    rx: 10,
    fill: "#2196F3",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: -11.5,
    width: 179,
    height: 38,
    rx: 3.5,
    stroke: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.86524 10.6747C7.88125 10.6951 7.9017 10.7116 7.92505 10.7229C7.9484 10.7342 7.97403 10.7401 8 10.7401C8.02597 10.7401 8.0516 10.7342 8.07495 10.7229C8.0983 10.7116 8.11875 10.6951 8.13476 10.6747L10.5305 7.65554C10.6182 7.54474 10.539 7.38068 10.3957 7.38068H8.8107V0.170455C8.8107 0.0767045 8.73369 0 8.63957 0H7.35615C7.26203 0 7.18503 0.0767045 7.18503 0.170455V7.37855H5.60428C5.46096 7.37855 5.38182 7.54261 5.46952 7.65341L7.86524 10.6747ZM15.8289 9.92898H14.5455C14.4513 9.92898 14.3743 10.0057 14.3743 10.0994V13.3807H1.62567V10.0994C1.62567 10.0057 1.54866 9.92898 1.45455 9.92898H0.171123C0.0770053 9.92898 0 10.0057 0 10.0994V14.3182C0 14.6953 0.305882 15 0.684492 15H15.3155C15.6941 15 16 14.6953 16 14.3182V10.0994C16 10.0057 15.923 9.92898 15.8289 9.92898Z",
    fill: "#2563EB"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -61,
    y: -550,
    width: 746,
    height: 904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleDownload);
export default __webpack_public_path__ + "static/media/SampleDownload.71af107c14e6ef43a259b5e36d409ed1.svg";
export { ForwardRef as ReactComponent };